import React from 'react';
import { Box, Text, Tooltip } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import ChildrenType from '../../../../../../../../../../../types/ChildrenType';

const LimitTooltip = ({ limitName, requiredText, children }) => {
  const label = (
    <Box>
      <Text as="span" color="greyScale.700">{limitName}</Text>
      {': '}
      <Text as="span">{requiredText}</Text>
    </Box>
  );

  return (
    <Tooltip
      label={label}
      placement="bottom-start"
      variant="light"
    >
      {children}
    </Tooltip>
  );
};

LimitTooltip.propTypes = {
  limitName: PropTypes.string.isRequired,
  requiredText: PropTypes.string.isRequired,
  children: ChildrenType.isRequired
};

export default LimitTooltip;
